import React, {FunctionComponent} from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

const IconLeft: FunctionComponent<IconProps> = ({
  className, height, title,
}) =>
  (
    <Icon className={className} height={height} title={title}>
      M2.20711 10.2071C2.10948 10.1095 2.10948 9.95118 2.20711 9.85355L10.6464 1.41421C10.8417 1.21895 10.8417 0.902369
      10.6464 0.707107L10.2929 0.353553C10.0976 0.158291 9.78105 0.158291 9.58579 0.353553L0.262564 9.67678C0.0673018
      9.87204 0.0673008 10.1886 0.262564 10.3839L9.58579 19.7071C9.78105 19.9024 10.0976 19.9024 10.2929 19.7071L10.6464
      19.3536C10.8417 19.1583 10.8417 18.8417 10.6464 18.6464L2.20711 10.2071Z
    </Icon>
  );

export default IconLeft;
